// extracted by mini-css-extract-plugin
module.exports = {"Gradient":"SectionRotate_Gradient__MA8HO"};